const cueSet2 = [
  {
          "duration": 0.612244,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 0,
          "time": 0,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 15360,
          "time": 0.612244,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 30720,
          "time": 1.224488,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 46080,
          "time": 1.836732,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 61440,
          "time": 2.448976,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 76800,
          "time": 3.06122,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 92160,
          "time": 3.673464,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.30612199999999934,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 99840,
          "time": 3.9795860000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 107520,
          "time": 4.285708,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 115200,
          "time": 4.59183,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 122880,
          "time": 4.897952,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999996,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 138240,
          "time": 5.5101960000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999996,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 153600,
          "time": 6.12244,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 168960,
          "time": 6.734684,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 54,
          "name": "F#3",
          "ticks": 184320,
          "time": 7.346928,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999987,
          "durationTicks": 15360,
          "midi": 54,
          "name": "F#3",
          "ticks": 199680,
          "time": 7.959172000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 54,
          "name": "F#3",
          "ticks": 215040,
          "time": 8.571416,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 59,
          "name": "B3",
          "ticks": 222720,
          "time": 8.877538,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 54,
          "name": "F#3",
          "ticks": 230400,
          "time": 9.18366,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 59,
          "name": "B3",
          "ticks": 238080,
          "time": 9.489782,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 245760,
          "time": 9.795904,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 261120,
          "time": 10.408148,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999987,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 276480,
          "time": 11.020392000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 291840,
          "time": 11.632636,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 307200,
          "time": 12.24488,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999987,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 322560,
          "time": 12.857124,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 337920,
          "time": 13.469368,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 345600,
          "time": 13.77549,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 353280,
          "time": 14.081612,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061220000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 360960,
          "time": 14.387734,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 1.224488000000001,
          "durationTicks": 30720,
          "midi": 66,
          "name": "F#4",
          "ticks": 368640,
          "time": 14.693856,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 1.2244879999999974,
          "durationTicks": 30720,
          "midi": 59,
          "name": "B3",
          "ticks": 399360,
          "time": 15.918344000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 430080,
          "time": 17.142832,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 445440,
          "time": 17.755076,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 460800,
          "time": 18.36732,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 476160,
          "time": 18.979564,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 491520,
          "time": 19.591808,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 506880,
          "time": 20.204052,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 522240,
          "time": 20.816296,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 537600,
          "time": 21.42854,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 552960,
          "time": 22.040784000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 568320,
          "time": 22.653028,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 583680,
          "time": 23.265272,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.30612199999999845,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 591360,
          "time": 23.571394,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 599040,
          "time": 23.877516,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.30612199999999845,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 606720,
          "time": 24.183638000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 614400,
          "time": 24.48976,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 629760,
          "time": 25.102004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 645120,
          "time": 25.714248,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 660480,
          "time": 26.326492000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 54,
          "name": "F#3",
          "ticks": 675840,
          "time": 26.938736,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 54,
          "name": "F#3",
          "ticks": 691200,
          "time": 27.55098,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 54,
          "name": "F#3",
          "ticks": 706560,
          "time": 28.163224,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.30612199999999845,
          "durationTicks": 7680,
          "midi": 59,
          "name": "B3",
          "ticks": 714240,
          "time": 28.469346,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 54,
          "name": "F#3",
          "ticks": 721920,
          "time": 28.775468,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.30612199999999845,
          "durationTicks": 7680,
          "midi": 59,
          "name": "B3",
          "ticks": 729600,
          "time": 29.081590000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 737280,
          "time": 29.387712,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 752640,
          "time": 29.999956,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 768000,
          "time": 30.6122,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122440000000005,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 783360,
          "time": 31.224444000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 798720,
          "time": 31.836688000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 814080,
          "time": 32.448932,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 829440,
          "time": 33.061176,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 837120,
          "time": 33.367298,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 844800,
          "time": 33.67342,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 852480,
          "time": 33.979542,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 1.224488000000001,
          "durationTicks": 30720,
          "midi": 66,
          "name": "F#4",
          "ticks": 860160,
          "time": 34.285664,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 1.224488000000001,
          "durationTicks": 30720,
          "midi": 59,
          "name": "B3",
          "ticks": 890880,
          "time": 35.510152,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 921600,
          "time": 36.73464,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 936960,
          "time": 37.346884,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 952320,
          "time": 37.959128,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 960000,
          "time": 38.26525,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 967680,
          "time": 38.571372000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 975360,
          "time": 38.877494,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 983040,
          "time": 39.183616,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 998400,
          "time": 39.79586,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 1013760,
          "time": 40.408104,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 1029120,
          "time": 41.020348,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 1044480,
          "time": 41.632592,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 57,
          "name": "A3",
          "ticks": 1059840,
          "time": 42.244836,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 1075200,
          "time": 42.85708,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 1082880,
          "time": 43.163202,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 1090560,
          "time": 43.469324,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 57,
          "name": "A3",
          "ticks": 1098240,
          "time": 43.775446,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1105920,
          "time": 44.081568000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1121280,
          "time": 44.693812,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1136640,
          "time": 45.306056,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1152000,
          "time": 45.9183,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 54,
          "name": "F#3",
          "ticks": 1167360,
          "time": 46.530544,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 54,
          "name": "F#3",
          "ticks": 1182720,
          "time": 47.142788,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 54,
          "name": "F#3",
          "ticks": 1198080,
          "time": 47.755032,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 59,
          "name": "B3",
          "ticks": 1205760,
          "time": 48.061154,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 54,
          "name": "F#3",
          "ticks": 1213440,
          "time": 48.367276000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 59,
          "name": "B3",
          "ticks": 1221120,
          "time": 48.673398,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1228800,
          "time": 48.97952,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1244160,
          "time": 49.591764,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1259520,
          "time": 50.204008,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1274880,
          "time": 50.816252,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1290240,
          "time": 51.428496,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 61,
          "name": "C#4",
          "ticks": 1305600,
          "time": 52.04074,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 1320960,
          "time": 52.652984000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 1328640,
          "time": 52.959106,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 1336320,
          "time": 53.265228,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 61,
          "name": "C#4",
          "ticks": 1344000,
          "time": 53.57135,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 1.224488000000001,
          "durationTicks": 30720,
          "midi": 66,
          "name": "F#4",
          "ticks": 1351680,
          "time": 53.877472,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 1.224488000000001,
          "durationTicks": 30720,
          "midi": 59,
          "name": "B3",
          "ticks": 1382400,
          "time": 55.10196,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.612244000000004,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 1413120,
          "time": 56.326448,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.6122439999999969,
          "durationTicks": 15360,
          "midi": 64,
          "name": "E4",
          "ticks": 1428480,
          "time": 56.938692,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 1443840,
          "time": 57.550936,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 1451520,
          "time": 57.857058,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.3061219999999949,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 1459200,
          "time": 58.163180000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.306122000000002,
          "durationTicks": 7680,
          "midi": 64,
          "name": "E4",
          "ticks": 1466880,
          "time": 58.469302,
          "velocity": 0.7874015748031497
        }
];

export default cueSet2;
